<template>
  <article class="">
    <section>
      <h3 style="text-align: center">Invitaciones</h3>
      <v-text-field
        v-for="(email, index) in emails"
        name="email"
        label="Correo"
        type="text"
        v-model="email.email"></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addEmail()">Agregar invitado</v-btn>
      <v-btn
        color="blue"
        @click="createInvitation()">Crear</v-btn>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      emails: [{
        email: ''
      }],
      data: {
        attributes: {
          user_id: this.getUserId(),
          from: null,
          until: null
        },
        invited_users_attributes:[]
      }
    }
  },
  methods:{
    createInvitation(){
      let vm = this
      this.data.invited_users_attributes = this.filterEmptyEmails(this.emails)
      this.data.invited_users_attributes = [...new Set(vm.data.invited_users_attributes.map(item => item.email))].map(function(x){return {email: x}})
      try {
        this.$http.post('invitations/create', {
          data: this.encrypt(this.data).toString()
        },
        {headers:{
          "X-Device-ID" : this.getDeviceId(),
          "Authorization" : 'Bearer ' + this.getUserToken()
        }}).then(function(response){
          if(vm.getUserType=='AgreementAdminUser'){
            this.$router.push({name: 'agreement_invitations_index', params: {id: this.getUserId()}})
          }else{
            this.$router.push({name: 'invitations'})
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }

    },
    addEmail(){
      let new_email = {email: ''}
      this.emails.push(new_email)
    },
    filterEmptyEmails (arr){
      return arr.filter(function(ele){return ele.email != ''})
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index ? self : null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/New.vue